var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmashball(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53091 1.93182V11.8182H0.608184C0.494548 11.2273 0.440002 10.6227 0.440002 10C0.440002 6.68636 2.04909 3.75 4.53091 1.93182ZM1.12182 13.6364H4.53091V18.0682C3.01273 16.9545 1.81728 15.4182 1.12182 13.6364ZM9.07637 13.6364H19.7582C18.3036 17.3591 14.6809 20 10.44 20C9.97637 20 9.52182 19.9682 9.07637 19.9045V13.6364ZM20.44 10C20.44 10.6227 20.3855 11.2273 20.2718 11.8182H9.07637V0.0954546C9.52182 0.0318182 9.97637 0 10.44 0C15.9627 0 20.44 4.47727 20.44 10Z",
    fill: "#A8A29E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmashball);
export default __webpack_public_path__ + "static/media/smashball.14af5503762ab18cd79530e90093d217.svg";
export { ForwardRef as ReactComponent };